import { Modal, Space } from "antd";
import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import { useFixtureService } from "~pages/Fixtures/hooks";
import type { FixtureTransformed } from "~pages/Fixtures/types";

interface IDeleteFixtureActionProperties {
  fixture: FixtureTransformed;
}

export const DeleteFixtureAction = (properties: IDeleteFixtureActionProperties) => {
  const { formatMessage } = useIntl();
  const { deleteFixture, isDeletePending: isDeleteFixtureInProcess } = useFixtureService();
  const [modal, contextHolder] = Modal.useModal();

  const onClickHandler = () => {
    if (
      !isEmpty(properties.fixture.homeCompetitor) ||
      !isEmpty(properties.fixture.awayCompetitor) ||
      !isEmpty(properties.fixture.homeParticipants) ||
      !isEmpty(properties.fixture.awayParticipants)
    ) {
      modal.warning({
        title: formatMessage({ id: "fixture.delete" }),
        content: formatMessage({ id: "fixture.delete.teams.exist" }),
        okText: formatMessage({ id: "ok" }),
      });
    } else {
      modal.confirm({
        title: formatMessage({ id: "fixture.delete" }),
        content: formatMessage({ id: "fixture.delete.confirm" }),
        okText: formatMessage({ id: "delete" }),
        okButtonProps: { loading: isDeleteFixtureInProcess },
        onOk: () => deleteFixture(properties.fixture.fixtureId),
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Space style={{ columnGap: "5px" }} onClick={onClickHandler}>
        <i className="fas fa-trash-can text-danger mr-2" />
        {formatMessage({ id: "match.delete" })}
      </Space>
    </>
  );
};
